import { CANCELLATION_OPTIONS, SAAS_PLANS, TEAM_ROLE_LABELS } from 'modules/arena/onboarding/content';
import { Card } from 'shared/components/ui/Card';
import { Badge } from 'shared/components/ui/Badge';
import { ArenaOnboardingState } from 'modules/arena/onboarding/useArenaOnboarding';

export function StepReview(state: ArenaOnboardingState) {
  const plan = SAAS_PLANS.find((item) => item.id === state.planId);
  const cancellation = CANCELLATION_OPTIONS.find((item) => item.value === state.cancellationWindow);

  return (
    <div className="flex flex-col gap-4">
      <p className="text-sm text-ink-secondary">
        Confira os dados antes de concluir. Você pode voltar em qualquer etapa para ajustar.
      </p>

      <Card>
        <p className="text-xs font-semibold uppercase tracking-wide text-ink-secondary">Arena</p>
        <p className="mt-1 font-medium text-ink">{state.arenaName || 'Sem nome definido'}</p>
        <p className="text-sm text-ink-secondary">
          {state.unitName} · {state.address || 'endereço não informado'} · {state.city}
        </p>
        <div className="mt-2 flex flex-wrap gap-1">
          {state.selectedSportIds.map((sport) => (
            <Badge key={sport} tone="accent">
              {sport}
            </Badge>
          ))}
        </div>
      </Card>

      <Card>
        <p className="text-xs font-semibold uppercase tracking-wide text-ink-secondary">Quadras</p>
        <ul className="mt-2 flex flex-col gap-1 text-sm text-ink">
          {state.courts.map((court) => (
            <li key={court.id}>
              {court.name} · {court.sportIds.join(', ') || 'sem esporte definido'} · R${' '}
              {court.pricePerHour}/h
            </li>
          ))}
        </ul>
      </Card>

      <Card>
        <p className="text-xs font-semibold uppercase tracking-wide text-ink-secondary">
          Horário de funcionamento
        </p>
        <p className="mt-1 text-sm text-ink">
          {state.openDays.join(', ')} · {state.openTime} às {state.closeTime}
        </p>
      </Card>

      <Card>
        <p className="text-xs font-semibold uppercase tracking-wide text-ink-secondary">Equipe</p>
        {state.team.length === 0 ? (
          <p className="mt-1 text-sm text-ink-secondary">Nenhum membro adicionado ainda.</p>
        ) : (
          <ul className="mt-1 flex flex-col gap-1 text-sm text-ink">
            {state.team.map((member) => (
              <li key={member.id}>
                {member.name} · {TEAM_ROLE_LABELS[member.role]}
              </li>
            ))}
          </ul>
        )}
      </Card>

      <Card>
        <p className="text-xs font-semibold uppercase tracking-wide text-ink-secondary">
          Cancelamento e plano
        </p>
        <p className="mt-1 text-sm text-ink">{cancellation?.label}</p>
        <p className="text-sm text-ink">
          Plano {plan?.name} · R$ {plan?.price}/mês + 2% da plataforma
        </p>
      </Card>
    </div>
  );
}
